import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InterviewQuestion } from '@app/models/recruiting/interview-question.model';
import { Interview } from '@app/models/recruiting/interview.model';
import { JobPosting } from '@app/models/recruiting/job-posting.model';
import { Translatable } from '@app/types/translatable.type';

@Component({
    selector: 'app-job-posting-create-interview',
    templateUrl: './job-posting-create-interview.html',
    styleUrls: ['./job-posting-create-interview.style.scss'],
})
export class JobPostingCreateInterviewComponent implements OnInit {
    @Output() saveInterview = new EventEmitter();

    @Input() interview: Interview = new Interview();
    @Input() jobPosting: JobPosting;
    @Input() editMode = false;

    openQuestionDialog = false;
    headerTitle: Translatable = '';

    ngOnInit(): void {
        this.headerTitle = this.editMode
            ? { key: 'applicant-tracker.editInterviewName', params: { interviewName: this.interview?.name } }
            : { key: 'applicant-tracker.createInterviewFor', params: { jobPostingTitle: this.jobPosting?.title } };
    }
    async onSave(): Promise<void> {
        this.saveInterview.emit();
    }

    openAddQuestionDialog(): void {
        this.openQuestionDialog = true;
    }

    closeApplicantInterviewQuestionDialog(): void {
        this.openQuestionDialog = false;
    }

    addApplicantInterviewQuestion(interviewQuestion: InterviewQuestion): void {
        interviewQuestion.questionIndex = this.interview.interviewQuestions.length;
        this.interview.interviewQuestions.push(interviewQuestion);
        this.closeApplicantInterviewQuestionDialog();
    }

    handleInterviewQuestionsChanged(interviewQuestions: InterviewQuestion[]): void {
        this.interview.interviewQuestions = interviewQuestions;
    }
}
